import * as XLSX from 'xlsx';

function toSheetName(name) {
  const safe = String(name || 'Sheet')
    .replace(/[\\/?*:[\]]/g, ' ')
    .trim();
  return (safe || 'Sheet').slice(0, 31);
}

function cellDisplayLength(value) {
  if (value == null) return 0;
  if (typeof value === 'number') return value.toLocaleString().length;
  return String(value).length;
}

// Size each column to fit its longest value so the exported file is
// readable immediately, instead of every column defaulting to ~8 chars.
function computeColumnWidths(headers, rows) {
  return headers.map((header, colIndex) => {
    let max = cellDisplayLength(header);
    rows.forEach((row) => {
      const len = cellDisplayLength(row[colIndex]);
      if (len > max) max = len;
    });
    return { wch: Math.min(Math.max(max + 2, 10), 60) };
  });
}

export function exportRowsToExcel({ filename, sheetName, headers, rows }) {
  const workbook = XLSX.utils.book_new();
  const data = [headers, ...rows];
  const worksheet = XLSX.utils.aoa_to_sheet(data);

  worksheet['!cols'] = computeColumnWidths(headers, rows);
  if (worksheet['!ref']) {
    worksheet['!autofilter'] = { ref: worksheet['!ref'] };
  }

  XLSX.utils.book_append_sheet(workbook, worksheet, toSheetName(sheetName));
  XLSX.writeFile(workbook, filename);
}
